import React from "react";
import MonthGrid from "./month/monthGrid";
import { PeriodTypes } from "../../constants/periodTypes";
import WeekGrid from "./week/weekGrid";
import "./forecastCalendar.css";
import DayLayout from "./day/dayLayout";
import { useForecastContext } from "../../context/forecastContext";

const ForecastCalendar: React.FC = () => {
  const { forecastState } = useForecastContext();

  return (
    <div className="forecast-calendar-container">
      {forecastState.periodType === PeriodTypes.MONTHLY && <MonthGrid />}
      {forecastState.periodType === PeriodTypes.WEEKLY && <WeekGrid />}
      {forecastState.periodType === PeriodTypes.DAILY && <DayLayout />}
    </div>
  );
};

export default ForecastCalendar;
